import Montana1 from "./montana (1).webp";
import Montana2 from "./montana (2).webp";
import Montana3 from "./montana (3).webp";
import Montana4 from "./montana (4).webp";
import Montana5 from "./montana (5).webp";
import Montana6 from "./montana (6).webp";
import Montana7 from "./montana (7).webp";
import Montana8 from "./montana (8).webp";

const montana = [
  Montana1,
  Montana2,
  Montana3,
  Montana4,
  Montana5,
  Montana6,
  Montana7,
  Montana8,
];

export default montana;
